import React, { useState } from 'react';
import { Form, Modal } from 'react-bootstrap';
import { put } from '../../../services/apiController';
import { toast } from 'react-toastify';

const DocumentUploadModal = ({ documentType, agreementId, open, onClose, callback, ownerDetailId }) => {
  const [documents, setDocuments] = useState(null);

  const handleFileChange = (event) => {
    const { files } = event.target;
    const updatedFiles = documentType === 'ownerAadharImages' || documentType === 'agreementFiles' ? files : files[0];
    setDocuments(updatedFiles);
  };

  const handleSubmit = async () => {
    if (!documents) {
      toast.error('Please select files to upload');
      return;
    }

    const formData = new FormData();
    if (documentType === 'ownerAadharImages' || documentType === 'agreementFiles') {
      for (let i = 0; i < documents.length; i++) {
        formData.append(documentType, documents[i]);
      }
    } else {
      formData.append(documentType, documents);
    }
    // Specific owner document upload (Send owner detail id key)
    if (ownerDetailId) formData.append('ownerDetailId', ownerDetailId);

    try {
      const res = await put(formData, `/agreements/documents/${agreementId}`, false);
      toast.success(res?.data?.message);
      setDocuments([]);
      onClose();
      callback();
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  };

  return (
    <Modal size="sm" show={open} backdrop="static" keyboard={false} className="request-modal">
      <Modal.Header>
        <Modal.Title>Upload Document</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Control
          name={documentType}
          multiple={documentType === 'ownerAadharImages' || documentType === 'agreementFiles'}
          onChange={handleFileChange}
          type="file"
          required
          autoComplete="false"
        />
      </Modal.Body>
      <Modal.Footer>
        <div className="btn-wrapper">
          <button onClick={onClose} className="btn app-btn-default btn-sm">
            Cancel
          </button>
          <button onClick={handleSubmit} className="btn app-btn-primary btn-sm">
            Upload
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default DocumentUploadModal;
